/* eslint-disable */
import React from 'react';
import { styled } from "@mui/material/styles";
import { Link } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import SideMenuItems from './SideMenuItems';
import '../style/sideMenu.css';
import '../style/common.css';
import brandLogo from '../assets/brand-logo.jpg';
import { useTranslation } from 'react-i18next';

const drawerWidth = '14.8rem';


const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
  textAlign: "center",
  paddingTop: "18px"
}));





const SideMenu = () => {
  const { t } = useTranslation();  // Use the translation hook
  const activeMenu = window.location.pathname.slice(1).split('/')[0];
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxShadow: "0px 3px 6px #00000029",
          backgroundColor: '#F0F0F0'
        }
      }}
      variant="persistent"
      anchor="left"
      open
    >
        <DrawerHeader
          sx={{
            boxShadow: '0px 3px 6px #00000029',
            backgroundColor: '#FFF',
            height: 120
          }}
        >
          <div><img height={80} src={brandLogo} alt="logo" /></div>
        </DrawerHeader>
        <List>
          {SideMenuItems.map((menu) => {
            return (
              <ListItem key={menu.route}
                className="sideMenuItem mt-10"
                sx={{
                  height: "35px",
                  "&.Mui-selected": {
                    color: "#123261",
                    backgroundColor: "#EDF6F4",
                    height: "35px",
                  }
                }}

                selected={activeMenu === menu.route || menu.subRoutes.includes(activeMenu)}>
                <Link key={menu.route} to={`/${menu.route}`} className='sideMenuLink'>
                  <ListItemText key={menu.route} className='s-bold' primary={menu.name} sx={{ '& .MuiTypography-root': { fontFamily: '' } }} />
                </Link>
            </ListItem>)
          })}
        </List>
    </Drawer>

  )

}


export default SideMenu;